
import * as h3 from "h3-js";
import { IVeriMapComponent } from "@directives/_map/veriMap/veriMapComponent/veriMap.component";

export interface h3DensityMap {
    count: number,
    density: number,
    h3array: string[]
}

export class h3Service {

    createHeatmap(veriMap: IVeriMapComponent, h3Map: Map<string, number>, densityMap: h3DensityMap[]) {
        veriMap.getMap().data.forEach((feature) => {
            veriMap.getMap().data.remove(feature);
        });

        var maxCount = 1;

        h3Map.forEach((value, key) => {
            maxCount = Math.max(value, maxCount);
        });

        densityMap.forEach(d => {
            var megaPolygon = h3.h3SetToMultiPolygon(d.h3array, true);

            var data = {
                type: "FeatureCollection",
                features: [{
                    type: "Feature",
                    properties: {
                        fillColor: this.getHeatmapColor(d.density)
                    },
                    geometry: {
                        type: "MultiPolygon",
                        coordinates: megaPolygon
                    }
                }]
            };

            veriMap.getMap().data.addGeoJson(data);
            veriMap.getMap().data.setStyle((feature) => {
                return {
                    fillColor: feature.getProperty('fillColor'),
                    strokeWeight: 0,
                    //strokeColor: this.getHeatmapColor(1),
                    fillOpacity: 1
                };
            });
        });
    }

    createH3DensityMap(h3Map: Map<string, number>, maxCount: number): h3DensityMap[] {
        var h3StringArray: h3DensityMap[] = [];

        h3Map.forEach((value, key) => {
            var matchingarray: h3DensityMap = null;
            var density = value / maxCount;
            var roundedDensity = Math.ceil(density * 5) / 5;
            roundedDensity = Math.min(roundedDensity, 1);

            h3StringArray.forEach(array => {
                if (matchingarray) { return; }

                if (roundedDensity == array.density) {
                    matchingarray = array;
                }
            });

            if (!matchingarray) {
                matchingarray = {
                    count: value,
                    density: roundedDensity,
                    h3array: []
                };

                h3StringArray.push(matchingarray);
            }

            matchingarray.h3array.push(key);
        });

        //console.log(h3StringArray);

        return h3StringArray;
    }

    getHeatmapColor(density: number): string {

        density = Math.min(density, 1); // Dont go above 1
        density = Math.max(density, 0.25); // Dont go below 0.3

        return `rgba(194, 46, 0,${density})`;

        if (density >= 0.3) {
            return `rgba(194, 46, 0,0.8)`;
        }

        if (density >= 0.1) {
            return `rgba(194, 46, 0,0.5)`;
            return `rgba(221, 119, 85, 0.7)`;
        }

        return `rgba(248, 192, 170, 0.5)`;
    }
}
